// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jBST5f4JTZVwi_2QccEP {\n  width: 11rem;\n  height: 3rem;\n}\n", "",{"version":3,"sources":["webpack://./src/features/logo/Logo.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;AACF","sourcesContent":[".logo {\n  width: 11rem;\n  height: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": "jBST5f4JTZVwi_2QccEP"
};
export default ___CSS_LOADER_EXPORT___;
